app.component("preOpPatientCareTeam", {
	templateUrl: "app/src/js/components/patientCareTeam/patientCareTeam.html",
	controller: "patientCareTeamController",
	bindings: {
		hide: "&",
	},
});

app.controller("patientCareTeamController", [
	"$modal",
	"$scope",
	"$timeout",
	"CurrentPatient",
	"Session",
	"PatientCareTeamAPI",
	"UserService",
	"PracticeService",
	"CARETEAM_TYPE",
	"PRACTICE_TYPE",
	"USER_ROLE",
	"PatientRecordLiveUpdateService",
	function (
		$modal, $scope, $timeout, 
		CurrentPatient, Session, 
		PatientCareTeamAPI, UserService, PracticeService,
		CARETEAM_TYPE, PRACTICE_TYPE, USER_ROLE, PatientRecordLiveUpdateService) {
		
		$scope.loadingData = true;
		$scope.isSubmitting = false;
		$scope.CareTeam_Types = CARETEAM_TYPE;

		this.$onInit = function () {
			$scope.practiceInfoInput = "";
			$scope.practiceContactInfo = [];
			$scope.formData = { };
			// Holds the search box's selection. Until the user typed something, this was only ever brought
			// into being by the ng-model behind the search box writing through searchTerm.newCareTeamValue
			// .data.name, so adding before typing read it while it did not exist yet.
			$scope.searchTerm = { newCareTeamValue: null };

			loadCareTeam();
			$scope.loadingData = false;

			// The care team changes without anyone touching it - a referral upload adds its GP, a
			// note adds its author - and other users add to it too. Re-read the list when that
			// happens, in place, with no loading state: the rows simply come to match.
			PatientRecordLiveUpdateService.subscribeCareTeam($scope, {
				patientId: function () {
					return CurrentPatient.patient && CurrentPatient.patient.id;
				},
				reload: loadCareTeam,
			});
		};

		function loadCareTeam() {
			if (!CurrentPatient.patient || !CurrentPatient.patient.id || !Session.hasPermission("PATIENT_VIEW")) {
				return;
			}
			PatientCareTeamAPI.queryPatientCareTeam(CurrentPatient.patient.id)
				.then((resp) => {
					$scope.patientCareTeams = resp.data
						.filter((careTeam) => {
							if (careTeam.patient_care_team_member_type == "CATTRAX_USER"
								|| careTeam.patient_care_team_member_type == "CATTRAX_PRACTICE"
								|| careTeam.patient_care_team_member_type == "PRACTICE_DIRECTORY")  
								{
									return careTeam;
								}
						})
						.map((careTeam) => {
							return mapCareTeamMember(careTeam);
						})
						.sort(sortCareTeamMembers);
				}, 
				(err) => {

				});
		}

		function sortCareTeamMembers(a, b) {
			if (a.careTeamType === b.careTeamType) return a.careTeamItemName.localeCompare(b.careTeamItemName);
			if (a.careTeamType === "CATTRAX_USER") {
				if (b.careTeamType === "CATTRAX_PRACTICE") return -1;
				if (b.careTeamType === "HPI_PRACTITIONER") return -1;
				if (b.careTeamType === "HPI_LOCATION") return -1;
				if (b.careTeamType === "HPI_ORGANISATION") return -1;
				if (b.careTeamType === "PRACTICE_DIRECTORY") return -1;
			}
			if (a.careTeamType === "CATTRAX_PRACTICE") {
				if (b.careTeamType === "HPI_PRACTITIONER") return -1;
				if (b.careTeamType === "HPI_LOCATION") return -1;
				if (b.careTeamType === "HPI_ORGANISATION") return -1;
				if (b.careTeamType === "PRACTICE_DIRECTORY") return -1;
			} 
			if (a.careTeamType === "PRACTICE_DIRECTORY") {
				if (b.careTeamType === "HPI_PRACTITIONER") return -1;
				if (b.careTeamType === "HPI_LOCATION") return -1;
				if (b.careTeamType === "HPI_ORGANISATION") return -1;
			}
			if (a.careTeamType === "HPI_PRACTITIONER") {
				if (b.careTeamType === "HPI_LOCATION") return -1;
				if (b.careTeamType === "HPI_ORGANISATION") return -1;
			}
			if (a.careTeamType === "HPI_LOCATION") {
				if (b.careTeamType === "HPI_ORGANISATION") return -1;
			}
			return 1
		}

		function mapCareTeamMember(careteamMember) {
			let careTeamMap = null;

			switch (careteamMember.patient_care_team_member_type) {
				case "CATTRAX_PRACTICE":
					const practiceTypeOption = PRACTICE_TYPE.find(x => x.value == careteamMember.practice_type);
					const practiceType = practiceTypeOption ? practiceTypeOption.name : careteamMember.practice_type;
					careTeamMap = {
						careTeamId: careteamMember.patient_care_team_member_id,
						careTeamType: careteamMember.patient_care_team_member_type,
						careTeamItemName: careteamMember.practice_name,
						careTeamItemType: practiceType,
						careTeamContactInfo: careteamMember.patient_care_team_contact_info
					}
					break;
				case "CATTRAX_USER":
					const userRoleType = (careteamMember.user_role_type || []).map(role => {
						const roleOption = USER_ROLE.find(x => x.id == role);
						return roleOption ? roleOption.label : role;
					}) 
					careTeamMap = {
						careTeamId: careteamMember.patient_care_team_member_id,
						careTeamType: careteamMember.patient_care_team_member_type,
						careTeamItemName: careteamMember.user_full_name,
						careTeamItemName_Practice: careteamMember.practice_name,
						careTeamItemType: userRoleType,
						careTeamContactInfo: careteamMember.patient_care_team_contact_info
					}
					break;
				case "PRACTICE_DIRECTORY":
					const practiceDirectoryRoleType = CARETEAM_TYPE.find(x => x.value == careteamMember.patient_care_team_member_type).name;
					careTeamMap = {
						careTeamId: careteamMember.patient_care_team_member_id,
						careTeamType: careteamMember.patient_care_team_member_type,
						careTeamItemName: careteamMember.practice_name,
						careTeamItemType: practiceDirectoryRoleType,
						careTeamContactInfo: careteamMember.patient_care_team_contact_info
					}
					break;
				
				/**
				 * There's the possibility that the HPI Practitons/Location/Organsiation data will be needed
				 * sometime in the future. 
				 * 
				 * These lines re-enable that functionality.
				 * 
				 * Disabled for now as the HPI endpoints take too long (10,000+ ms) to resolve
				 */
				// case "HPI_PRACTITIONER":
				// 	const hpiPractitionerRoleType = CARETEAM_TYPE.find(x => x.value == careteamMember.patient_care_team_member_type).name;
				// 	careTeamMap = {
				// 		careTeamId: careteamMember.patient_care_team_member_id,
				// 		careTeamType: careteamMember.patient_care_team_member_type,
				// 		careTeamItemName: careteamMember.hpi_practitioner_name,
				// 		careTeamItemType: hpiPractitionerRoleType,
				// 		careTeamContactInfo: careteamMember.patient_care_team_contact_info
				// 	}
				// 	break;
				// case "HPI_LOCATION":
				// 	const hpiLocationRoleType = CARETEAM_TYPE.find(x => x.value == careteamMember.patient_care_team_member_type).name;
				// 	careTeamMap = {
				// 		careTeamId: careteamMember.patient_care_team_member_id,
				// 		careTeamType: careteamMember.patient_care_team_member_type,
				// 		careTeamItemName: careteamMember.hpi_location_name,
				// 		careTeamItemType: hpiLocationRoleType,
				// 		careTeamContactInfo: careteamMember.patient_care_team_contact_info
				// 	}
				// 	break;
				// case "HPI_ORGANISATION":
				// 	const hpiOrganisationRoleType = CARETEAM_TYPE.find(x => x.value == careteamMember.patient_care_team_member_type).name;
				// 	careTeamMap = {
				// 		careTeamId: careteamMember.patient_care_team_member_id,
				// 		careTeamType: careteamMember.patient_care_team_member_type,
				// 		careTeamItemName: careteamMember.hpi_organisation_name,
				// 		careTeamItemType: hpiOrganisationRoleType,
				// 		careTeamContactInfo: careteamMember.patient_care_team_contact_info
				// 	}
				// 	break;
				default:
					break;
			}
			return careTeamMap;
		}

		$scope.onDeleteCareTeamMember = function(item) {
			PatientCareTeamAPI.deleteCareTeam(CurrentPatient.patient.id, item.careTeamId)
				.then((resp) => {
					let careTeamIndex = $scope.patientCareTeams.findIndex((careTeam) => {
						return careTeam.careTeamId == item.careTeamId;
					})
					// A live reload may already have dropped it; splice(-1) would remove the last row instead.
					if (careTeamIndex !== -1) {
						$scope.patientCareTeams.splice(careTeamIndex, 1);
					}
				});
		}


		$scope.fetchContactInfo = function (value) {
			$scope.contact_info_loading = true;
			return new Promise((resolve, reject) => {
				_fetchContactInfo(value, resolve, reject);
			});
		};

		//REGION: Add CareTeam Member Modal
		function _fetchContactInfo(searchValue, resolve, reject) {
			$scope.contact_info_noResults = false;

			Promise.all([
				UserService.searchUsers(searchValue),
				PracticeService.searchPractices(searchValue),
				PracticeService.searchPracticeDirectory(searchValue)
			])
				.then(
					(returnValues) => {
						let userData = returnValues[0].data;
						let practiceData = returnValues[1].data;
						let practiceDirectoryData = returnValues[2].data;

						// let hpiPractitionerData = returnValues[2].data;

						// let hpiLocationData = returnValues[3].data;
						// let hpiOrganisationData = returnValues[4].data;

						// Get all userData
						let userDataMap = userData.map((user) => {
							return {
								careTeamType: "CATTRAX_USER",
								data: {
									userId: user.id,
									name: `${user.title} ${user.firstName} ${user.lastName} (${user.practiceName})`,
									phoneNumber: user.practicePhoneNumber,
									email: user.practiceEmail,
									practiceId: user.practiceId,
								},
							};
						});

						// Get all practiceData, then format it in the display format.
						let practiceDataMap = practiceData.map((practice) => {
							return {
								careTeamType: "CATTRAX_PRACTICE",
								data: {
									...practice,
									userId: Session.userId,
									practiceId: practice.id,
								},
							};
						});

						let practiceDirectoryDataMap = practiceDirectoryData.map((directory) => {
							return {
								careTeamType: "PRACTICE_DIRECTORY",
								data: {
									practiceDirectoryId: directory.practice_directory_id,
									name: `(EDI) ${directory.practice_name} ${directory.region ? `(${directory.region})` : ""}`,
									edi: directory.practiceEdi,
									userId: Session.userId,
									practiceId: CurrentPatient.patient.practice.id
								}
							}
						})

						/**
						 * There's the possibility that the HPI Practitons/Location/Organsiation data will be needed
						 * sometime in the future. 
						 * 
						 * These lines re-enable that functionality.
						 * 
						 * Disabled for now as the HPI endpoints take too long (10,000+ ms) to resolve
						 */
						// let hpiPractitionerDataMap = hpiPractitionerData.map((practitioner) => {
						// 	return {
						// 		careTeamType: "HPI_PRACTITIONER",
						// 		data: {
						// 			//Quick and dirty is fine here. Use the first id.
						// 			practitionerId: practitioner.id[0].value,
						// 			name: `(HPI Practitioner) ${practitioner.name}`,
						// 			email: practitioner.email,
						// 			userId: Session.userId,
						// 			practiceId: CurrentPatient.patient.practice.id,
						// 		},
						// 	};
						// });

						// let hpiLocationDataMap = hpiLocationData.map((location) => {
						// 	return {
						// 		careTeamType: "HPI_LOCATION",
						// 		data: {
						// 			locationId: location.location_id[0].value,
						// 			name: `(HPI Location) ${location.name}`,
						// 			email: location.email,
						// 			userId: Session.userId,
						// 			practiceId: CurrentPatient.patient.practice.id,
						// 		},
						// 	};
						// });

						// let hpiOrganisationDataMap = hpiOrganisationData.map((organisation) => {
						// 	return {
						// 		careTeamType: "HPI_ORGANISATION",
						// 		data: {
						// 			organisationId: organisation.organisation_id[0].value,
						// 			name: `(HPI Organisation) ${organisation.name}`,
						// 			email: organisation.email,
						// 			userId: Session.userId,
						// 			practiceId: CurrentPatient.patient.practice.id,
						// 		},
						// 	};
						// });
						resolve([
							...userDataMap,
							...practiceDataMap,
							...practiceDirectoryDataMap
						// 	...hpiPractitionerDataMap,
						// 	...hpiLocationDataMap,
						// 	...hpiOrganisationDataMap,
						]);
					},
					(error) => {
						$scope.contact_info_noResults = true;
						resolve([]);
					}
				)
				.then(() => {
					$scope.contact_info_loading = false;
				});
		}

		$scope.onSelectPatientInfo = function(item) {
			
			let contactArray = [];
			if(item.data.phoneNumber) {
				contactArray.push({
						type: "Phone:",
						detail: item.data.phoneNumber
					})
			}
			if(item.data.email) {
				contactArray.push({
						type: "Email:",
						detail: item.data.email
					})
			}
			if(item.data.edi) {
				contactArray.push({
					type: "EDI:",
					detail: item.data.edi
				})
			}

			$scope.practiceContactInfo = contactArray;
			$scope.searchTerm.newCareTeamValue = item;
		}

		$scope.validateCareTeamContactInfo = function(newContactInfo) {

			function isValidPhone(phone){
				return /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(phone);
			}
			function isValidEmail(email) {
				return /\S+@\S+\.\S+/.test(email);
			}

			$scope.practiceContactInfo.pop()
			if (isValidPhone(newContactInfo)) {
				$scope.practiceContactInfo.push({
					type: "Phone:",
					detail: newContactInfo
				})
				return;
			} 
			else if (isValidEmail(newContactInfo)) {
				$scope.practiceContactInfo.push({
					type: "Email:",
					detail: newContactInfo
				})
				return;
			}


		}

		/**
		 * Whether there is a search result to add. Typing in the search box writes straight through to the
		 * model, so a half-typed name looks like a value while carrying none of the ids the member is
		 * built from - only picking a result out of the list fills those in, and only those results carry
		 * a careTeamType.
		 */
		$scope.hasCareTeamMemberToAdd = function() {
			const newCareTeamInput = $scope.searchTerm.newCareTeamValue;
			return !!(newCareTeamInput && newCareTeamInput.careTeamType && newCareTeamInput.data);
		}

		$scope.submitNewCareTeamMember = function() {
			// Guard against double submission: ignore further clicks while the add is
			// in flight (the add icon is also greyed out until it resolves).
			if ($scope.isSubmitting) {
				return;
			}

			// Nothing picked out of the search list yet, so there is nothing to add. The add icon is
			// greyed out in this state, and it is checked here because an image cannot be disabled.
			if (!$scope.hasCareTeamMemberToAdd()) {
				return;
			}

			let newCareTeamInput = $scope.searchTerm.newCareTeamValue;

			$scope.isSubmitting = true;
			PatientCareTeamAPI.createCareTeam(CurrentPatient.patient.id, {
				patient_id: CurrentPatient.patient.id,
				patient_care_team_member_type: newCareTeamInput.careTeamType,
				user_id: newCareTeamInput.data.userId,
				practice_id: newCareTeamInput.data.practiceId,
				hpi_practitioner_id: newCareTeamInput.data.practitionerId,
				hpi_location_id: newCareTeamInput.data.locationId,
				hpi_organisation_id: newCareTeamInput.data.organisationId,
				practice_directory_id: newCareTeamInput.data.practiceDirectoryId
			})
			.then((resp) => {
				let newCareTeam = mapCareTeamMember(resp.data);

				let isDuplicate = $scope.patientCareTeams.some((careTeam) => {
					return careTeam.careTeamId == newCareTeam.careTeamId;
				})

				if(!isDuplicate) {
					$scope.patientCareTeams.push(newCareTeam);
					$scope.patientCareTeams.sort(sortCareTeamMembers);
				}

				$scope.searchTerm.newCareTeamValue = null;
				$scope.practiceContactInfo = [];
			},
			(err) => {

			})
			.finally(() => {
				$scope.isSubmitting = false;
			})
		}


		$scope.isArray = function(object) {
			return (object instanceof Array);
		}
		//ENDREGION
	}
]);
